import { classNames } from "primereact/utils";

import SetaLimiteIcon from "@/assets/icons/gantt-limite-seta.svg?react";

import { useGanttContext } from "../gantt.context";
import styles from "../gantt.module.scss";

/** Cabeçalho: as colunas fixas, a escala (ano, mês, dia), a seta do limite, a bolinha do Hoje e a coluna ⋮. */
export function GanttHeaderView() {
  const {
    columns,
    headerRows,
    headerRowCount,
    headerMarkers,
    headerTestId,
    todayStyle,
    todayLabel,
    todayLabelTestId,
    withActions,
    scaleRef,
    actionsHeaderLabel,
    classNames: partClassNames,
  } = useGanttContext();

  return (
    <div
      className={classNames(styles.row, styles.headerRow, partClassNames.header)}
      data-rows={headerRowCount}
      data-testid={headerTestId}
      role="row"
    >
      {columns.map((column) => (
        <div
          key={column.key}
          className={classNames(styles.cell, styles.headerCell, partClassNames.headerCell)}
          style={column.style}
          role="columnheader"
        >
          {column.header}
        </div>
      ))}
      <div
        ref={scaleRef}
        className={classNames(styles.track, styles.scale, partClassNames.scale)}
        role="columnheader"
      >
        {headerRows.map((headerRow) => (
          <div
            key={headerRow.kind}
            className={styles.scaleRow}
            data-kind={headerRow.kind}
            data-position={headerRow.position}
          >
            {headerRow.bands.map((band) => (
              <span
                key={band.key}
                className={styles.band}
                style={band.style}
                data-divider={band.divider}
              >
                <span className={styles.bandLabel}>{band.label}</span>
              </span>
            ))}
          </div>
        ))}
        {headerMarkers.map((marker) => (
          <span
            key={marker.key}
            className={styles.limitHead}
            style={marker.style}
            data-testid={marker.testId}
            aria-hidden
          >
            <SetaLimiteIcon />
            <span className={styles.limitHeadLine} />
          </span>
        ))}
        {todayStyle ? <span className={styles.todayDot} style={todayStyle} aria-hidden /> : null}
        {todayLabel ? (
          <span
            className={styles.todayLabel}
            style={todayStyle ?? undefined}
            data-testid={todayLabelTestId}
            aria-hidden
          >
            {todayLabel}
          </span>
        ) : null}
      </div>
      {withActions ? (
        <div
          className={classNames(styles.actionsCell, styles.actionsHeader)}
          role="columnheader"
          aria-label={actionsHeaderLabel}
        />
      ) : null}
    </div>
  );
}
GanttHeaderView.displayName = "Gantt.Header";
